import React from "react";
import { Link } from "gatsby";
import resolveLink from "utils/resolveLink";

const TBBLink = ({
  children,
  className,
  to,
  style,
  target,
  onClick,
  activeClassName,
}) => {
  const classes = `cursor-pointer transition duration-300 ${
    className ? className : ""
  }`;

  return (
    // If there is no text don't display the button at all
    !children ? (
      ""
    ) : // If there is no target/link just output a div. This is to prevent the nested <a> problem
    !to ? (
      <div
        className={`${classes}`}
        activeClassName={activeClassName ? activeClassName : null}
        style={style}
        role="button"
        tabIndex="0"
        onClick={onClick ? onClick : null}
        onKeyPress={onClick ? onClick : null}
      >
        {children}
      </div>
    ) : // If the target is a non-gatsby target
    to.includes("tel:") ||
      to.includes("mailto:") ||
      target === "_blank" ||
      to.startsWith("www.") ||
      to.startsWith("https://") ? (
      <a
        className={`${classes}`}
        href={to.startsWith("www.") ? `https://${to}` : to}
        target={target}
        style={style}
        role="button"
        tabIndex="0"
        onClick={onClick ? onClick : null}
        onKeyPress={onClick ? onClick : null}
      >
        {children}
      </a>
    ) : (
      // Default
      <Link
        className={`${classes}`}
        to={resolveLink(to)}
        activeClassName={activeClassName ? activeClassName : null}
        style={style}
        role="button"
        tabIndex="0"
        onClick={onClick ? onClick : null}
        onKeyPress={onClick ? onClick : null}
      >
        {children}
      </Link>
    )
  );
};

export default TBBLink;
